var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoBase',{attrs:{"size":"xs4"}},[_c('Button',{attrs:{"outlined":"","block":"","title":"Open BottomSheet"},on:{"onClick":_vm.onButtonClick}}),_c('BottomSheet',{on:{"onClose":_vm.onBottomSheetClose},model:{value:(_vm.bottomSheet),callback:function ($$v) {_vm.bottomSheet=$$v},expression:"bottomSheet"}},[_vm._v(" Hello world ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }